import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ScriptsListView, RequestsDetail } from './components';
import { ScriptsProvider, useScriptsContext } from './context/ScriptsContext';
import { selectDarkTheme } from '@src/styles/darkTheme';
import { fadeInUpSX } from '@src/styles/animations';

const ScriptsContent = () => {
  const { selectedScript, isLoadingScript } = useScriptsContext();

  if (isLoadingScript || selectedScript) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', ...fadeInUpSX() }}>
        <RequestsDetail />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', ...fadeInUpSX() }}>
      <ScriptsListView />
    </Box>
  );
};

export const ScriptsContainer = () => {
  return (
    <ThemeProvider theme={selectDarkTheme}>
      <ScriptsProvider>
        <ScriptsContent />
      </ScriptsProvider>
    </ThemeProvider>
  );
};
